var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:[
      { 'grid--container': !_vm.fullwidth },
      `${_vm.name}__grid`,
      _vm.cms.style_grid,
    ],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[
        `${_vm.name}__grid-item`,
        `${_vm.name}__grid-content`,
        `${_vm.name}__column-one`,
      ],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},_vm._l((_vm.cms.column_one),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__content`,attrs:{"cms":item}})}),1),_vm._v(" "),_c('grid-item',{class:[
        `${_vm.name}__grid-item`,
        `${_vm.name}__grid-content`,
        `${_vm.name}__column-two`,
      ],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},_vm._l((_vm.cms.column_two),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__content`,attrs:{"cms":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }